export default __webpack_public_path__ + "static/media/Silvopasture_Aerial_timber_selective-cut_After3.139a585e.jpg";